export const NOTIFICATION_TYPES = {
  CUSTOMER_FORUM_POST: "CustomerForumPost",
  EMAIL_OPENED: "EmailOpen",
  EMAIL_RECEIVED: "EmailReceived",
  MISSED_CALL: "MissedCalls",
  AUDITION: "AuditionAssessment",
  MEETING: "MeetingFeedback",
  LIST_RECEIVED: "ListReceived",
  COLD_OUTREACH_EMAIL_RESPONDED: "ColdOutreachAnswered",
  QC_PRE_CHECK_SUCCEEDED: "QCPreCheckSucceeded",
  CALENDAR_INVITE_RECEIVED: "CalendarInviteReceived",
  DIAL_BLOCK_CHANGED: "DialBlockChanged",
  DIAL_BLOCK_AVAILABILITY_APPROVED: "DialBlockAvailabilityApproved",
  DIAL_BLOCK_AVAILABILITY_DENIED: "DialBlockAvailabilityDenied",
  // C-14 W3: a caller reached 3 strikes (to their LGAs and Pod Lead).
  DIAL_BLOCK_STRIKE_ALERT: "DialBlockStrikeAlert",
  // C-12 wave 2 B: a caller sent a block request (to their LGAs and Pod
  // Lead).
  DIAL_BLOCK_REQUEST_WAITING: "DialBlockRequestWaiting",
  // C-16 S1: an incentive the caller can earn started, or they won one.
  INCENTIVE_STARTED: "IncentiveStarted",
  INCENTIVE_WON: "IncentiveWon",
  // C-16 S4: a Top 10 lead's call-by time arrived, and the caller's morning
  // count of Top 10 leads due that day.
  TOP_TEN_DUE: "TopTenDue",
  TOP_TEN_DIGEST: "TopTenDigest",
  // C-16 S3: an LGA asks the booker to work one of their meetings (Team →
  // Pipeline's reminder menu).
  PIPELINE_REMINDER: "PipelineReminder",
} as const;
